export const PAGE = 'page';
export const POST = 'post';
export const GERMAN = 'german_edition';
export const FRENCH = 'french_edition';
export const ITALIAN = 'italian_edition';
export const POLISH = 'polish_edition';
export const PORTUGUESE = 'portuguese_edition';
export const SPANISH = 'spanish_edition';
export const SWEDISH = 'swedish_edition';
export const LANDING = 'landing-page';

export const searchTypes = [
  POST,
  GERMAN,
  FRENCH,
  ITALIAN,
  POLISH,
  PORTUGUESE,
  SPANISH,
  SWEDISH,
];

export default {
  PAGE,
  POST,
  GERMAN,
  FRENCH,
  ITALIAN,
  POLISH,
  PORTUGUESE,
  SPANISH,
  SWEDISH,
  LANDING,
};
